import styled from "styled-components";

const Container = styled.div`
  padding: 0px 30px 15px 30px;

  @media only screen and (max-width: 600px) {
    padding: 0px 15px 15px 15px;
  }
`;

export { Container };
